const isDevelopment = window.location.hostname === "localhost";

export const config = {
  googleMapsApiKey: "AIzaSyCcZ22W5-Xhznx8sAAZ4_uotbIH_7Gdjsg",
  logoSrc: "/Logosmall.png",
  flightSiteName: "Travel Website Duffel Flights",
  hotelSiteName: "Travel Website Duffel Stays",
  primaryColorBg: "bg-[#facc15]",
  primaryColorText: "text-[#facc15]",
  primaryColorRing: "ring-[#facc15]",
  backendServer: isDevelopment
    ? "http://localhost:5000"
    : "https://travel-website-duffel-flights.onrender.com",
  socialLinks: {
    linkedin: "https://linkedin.com/company/",
    facebook: "https://facebook.com/",
    twitter: "https://twitter.com/",
    instagram: "https://instagram.com/",
  },
  companyInfo: {
    name: "Travel Website Ltd",
    copyright: "© 2025 All rights reserved",
  },
  supportInfo: {
    phone: "+447493291667",
    email: "joshsparkes6@gmail.com",
  },
  pricing: {
    markupType: "percentage",
    markupValue: 2,
  },
  hotelPricing: {
    markupType: "percentage",
    markupValue: 5,
  },
};
